import React from 'react';
import HeroSlider from './HeroSlider';
import CTABanner from './CTABanner';
import ProductsPreview from './ProductsPreview';
import ServicesPreview from './ServicesPreview';
import AboutPreview from './AboutPreview';
import ContactSection from './ContactSection';

const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroSlider />
      <ProductsPreview />
      <ServicesPreview />
      <AboutPreview />
      <CTABanner />
      <ContactSection />
    </div>
  );
};

export default Home;